import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getCostSegEZAddress(currentPath: string, path?: string): string {
  return `https://costsegez.com${path ?? ''}?utm_medium=referral&utm_source=${encodeURIComponent(DOMAIN_NAME + currentPath)}`
}


export function slugify(input: string) {
  return (
    input
      .toLowerCase()
      .trim()
      // remove invalid chars
      .replace(/[^a-z0-9\s-]/g, "")
      // collapse whitespace and replace by -
      .replace(/\s+/g, "-")
      // collapse multiple -
      .replace(/-+/g, "-")
  )
}

export const DOMAIN_NAME = "https://mvocostseg.com"

export const PAGE_PATH = {
  RENTALS:'/learn',
};
